import Basic from "./basic.jsx";
import Error from "./error.jsx";

export default {
  Basic,
  Error,
};
